import rest from "rest";

export var http = rest
  .wrap(require('rest/interceptor/errorCode'))
  .wrap(require('rest/interceptor/mime'))
  .wrap(require("rest/interceptor/defaultRequest"), {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  });

export function wrap(interceptor) {
  http = http.wrap(interceptor);
}



/** WEBPACK FOOTER **
 ** ./client/app/shared/utils/http.util.ts
 **/